import { Link } from 'react-router-dom';
import { animeCategories } from '@/mocks/anime';

interface HeroSectionProps {
  onCategoryClick?: () => void;
}

export default function HeroSection({ onCategoryClick }: HeroSectionProps) {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20anime%20style%20artwork%20with%20warm%20orange%20red%20and%20gold%20color%20gradients%2C%20dynamic%20energy%20waves%2C%20stylized%20Japanese%20inspired%20patterns%2C%20clean%20modern%20composition%2C%20dark%20background%20with%20warm%20accents%2C%20cinematic%20atmosphere%2C%20no%20characters%20just%20abstract%20art&width=1600&height=900&seq=hero-bg-anime-01&orientation=landscape"
        alt="6080影视 - 动漫番剧免费在线观看"
        title="6080影视 - 动漫番剧免费高清在线观看平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-950"></div>

      <div className="container-custom relative z-10 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
          <span className="text-primary-300 text-xs md:text-sm font-medium">免费高清 · 不缓冲 · 流畅追番</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
          发现你的下一部
          <br />
          <span className="text-gradient">最爱动漫</span>
        </h1>
        <p className="text-foreground-400 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          海量免费动漫大全，覆盖日漫、国漫、经典番剧。高清画质流畅播放，
          每周同步更新，让动漫迷免费看个够。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
          <Link to="/category/all" className="btn-primary text-base px-8 py-3 rounded-full">
            <i className="ri-play-circle-line mr-2 text-lg"></i>
            立即追番
          </Link>
          <a href="#categories" className="btn-accent text-base px-8 py-3 rounded-full bg-transparent border-2 border-accent-500 text-accent-400 hover:bg-accent-500 hover:text-background-950" onClick={onCategoryClick}>
            <i className="ri-apps-line mr-2 text-lg"></i>
            浏览分类
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: '10000+', label: '动漫资源' },
            { value: '50万+', label: '日活跃用户' },
            { value: '1080P', label: '高清画质' },
            { value: '2小时内', label: '同步更新' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-3 rounded-lg bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-400">{stat.value}</div>
              <div className="text-foreground-500 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}